import { FC } from 'react'
import Opora from '@/assets/img/icons/opora.svg'
import { TypeIcon } from '@/components/Atoms/Icons/types'

const Icon: FC<TypeIcon> = ({ width = 30, height = 30 }) => {
  return (
    <img
      src={Opora}
      alt='IconLightTower'
      width={width}
      height={height}
    />
  )
}

export default Icon
